function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import getFileTypeExtension from '@uppy/utils/lib/getFileTypeExtension';
import supportsMediaRecorder from "./supportsMediaRecorder.js";
import RecordingScreen from "./RecordingScreen.js";
import PermissionsScreen from "./PermissionsScreen.js";
import locale from "./locale.js";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "1.1.9"
};
var _stream = /*#__PURE__*/_classPrivateFieldLooseKey("stream");
var _audioActive = /*#__PURE__*/_classPrivateFieldLooseKey("audioActive");
var _recordingChunks = /*#__PURE__*/_classPrivateFieldLooseKey("recordingChunks");
var _recorder = /*#__PURE__*/_classPrivateFieldLooseKey("recorder");
var _capturedMediaFile = /*#__PURE__*/_classPrivateFieldLooseKey("capturedMediaFile");
var _mediaDevices = /*#__PURE__*/_classPrivateFieldLooseKey("mediaDevices");
var _supportsUserMedia = /*#__PURE__*/_classPrivateFieldLooseKey("supportsUserMedia");
var _hasAudioCheck = /*#__PURE__*/_classPrivateFieldLooseKey("hasAudioCheck");
var _start = /*#__PURE__*/_classPrivateFieldLooseKey("start");
var _startRecording = /*#__PURE__*/_classPrivateFieldLooseKey("startRecording");
var _stopRecording = /*#__PURE__*/_classPrivateFieldLooseKey("stopRecording");
var _discardRecordedAudio = /*#__PURE__*/_classPrivateFieldLooseKey("discardRecordedAudio");
var _submit = /*#__PURE__*/_classPrivateFieldLooseKey("submit");
var _stop = /*#__PURE__*/_classPrivateFieldLooseKey("stop");
var _getAudio = /*#__PURE__*/_classPrivateFieldLooseKey("getAudio");
var _changeSource = /*#__PURE__*/_classPrivateFieldLooseKey("changeSource");
var _updateSources = /*#__PURE__*/_classPrivateFieldLooseKey("updateSources");
/**
 * Audio recording plugin
 */
var Audio = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Audio, _UIPlugin);
  function Audio(uppy, opts) {
    var _this;
    _classCallCheck(this, Audio);
    _this = _callSuper(this, Audio, [uppy, opts]);
    Object.defineProperty(_assertThisInitialized(_this), _getAudio, {
      value: _getAudio2
    });
    Object.defineProperty(_assertThisInitialized(_this), _hasAudioCheck, {
      value: _hasAudioCheck2
    });
    Object.defineProperty(_assertThisInitialized(_this), _stream, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this), _audioActive, {
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), _recordingChunks, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this), _recorder, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this), _capturedMediaFile, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this), _mediaDevices, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), _supportsUserMedia, {
      writable: true,
      value: void 0
    });
    // eslint-disable-next-line consistent-return
    Object.defineProperty(_assertThisInitialized(_this), _start, {
      writable: true,
      value: function value(options) {
        if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _supportsUserMedia)[_supportsUserMedia]) {
          return Promise.reject(new Error('Microphone access not supported'));
        }
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _audioActive)[_audioActive] = true;
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _hasAudioCheck)[_hasAudioCheck]().then(function (hasAudio) {
          _this.setPluginState({
            hasAudio: hasAudio
          });

          // ask user for access to their camera
          return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _mediaDevices)[_mediaDevices].getUserMedia({
            audio: true
          }).then(function (stream) {
            _classPrivateFieldLooseBase(_assertThisInitialized(_this), _stream)[_stream] = stream;
            var currentDeviceId = null;
            var tracks = stream.getAudioTracks();
            if (!(options != null && options.deviceId)) {
              currentDeviceId = tracks[0].getSettings().deviceId;
            } else {
              currentDeviceId = tracks.findLast(function (track) {
                return track.getSettings().deviceId === options.deviceId;
              });
            }

            // Update the sources now, so we can access the names.
            _classPrivateFieldLooseBase(_assertThisInitialized(_this), _updateSources)[_updateSources]();
            _this.setPluginState({
              currentDeviceId: currentDeviceId,
              audioReady: true
            });
          }).catch(function (err) {
            _this.setPluginState({
              audioReady: false,
              cameraError: err
            });
            _this.uppy.info(err.message, 'error');
          });
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _startRecording, {
      writable: true,
      value: function value() {
        // only used if supportsMediaRecorder() returned true
        // eslint-disable-next-line compat/compat
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder] = new MediaRecorder(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _stream)[_stream]);
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks] = [];
        var stoppingBecauseOfMaxSize = false;
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].addEventListener('dataavailable', function (event) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks].push(event.data);
          var restrictions = _this.uppy.opts.restrictions;
          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks].length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
            var totalSize = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks].reduce(function (acc, chunk) {
              return acc + chunk.size;
            }, 0);
            // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier
            var averageChunkSize = (totalSize - _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks][0].size) / (_classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks].length - 1);
            var expectedEndChunkSize = averageChunkSize * 3;
            var maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);
            if (totalSize > maxSize) {
              stoppingBecauseOfMaxSize = true;
              _this.uppy.info(_this.i18n('recordingStoppedMaxSize'), 'warning', 4000);
              _classPrivateFieldLooseBase(_assertThisInitialized(_this), _stopRecording)[_stopRecording]();
            }
          }
        });

        // use a "time slice" of 500ms: ondataavailable will be called each 500ms
        // smaller time slices mean we can more accurately check the max file size restriction
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].start(500);

        // Start the recordingLengthTimer if we are showing the recording length.
        // TODO: switch this to a private field
        _this.recordingLengthTimer = setInterval(function () {
          var currentRecordingLength = _this.getPluginState().recordingLengthSeconds;
          _this.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1000);
        _this.setPluginState({
          isRecording: true
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _stopRecording, {
      writable: true,
      value: function value() {
        var stopped = new Promise(function (resolve) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].addEventListener('stop', function () {
            resolve();
          });
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].stop();
          clearInterval(_this.recordingLengthTimer);
          _this.setPluginState({
            recordingLengthSeconds: 0
          });
        });
        return stopped.then(function () {
          _this.setPluginState({
            isRecording: false
          });
          return _classPrivateFieldLooseBase(_assertThisInitialized(_this), _getAudio)[_getAudio]();
        }).then(function (file) {
          try {
            _classPrivateFieldLooseBase(_assertThisInitialized(_this), _capturedMediaFile)[_capturedMediaFile] = file;
            // create object url for capture result preview
            _this.setPluginState({
              recordedAudio: URL.createObjectURL(file.data)
            });
          } catch (err) {
            // Logging the error, exept restrictions, which is handled in Core
            if (!err.isRestriction) {
              _this.uppy.log(err);
            }
          }
        }).then(function () {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder] = null;
        }, function (error) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder] = null;
          throw error;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _discardRecordedAudio, {
      writable: true,
      value: function value() {
        _this.setPluginState({
          recordedAudio: null
        });
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _capturedMediaFile)[_capturedMediaFile] = null;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _submit, {
      writable: true,
      value: function value() {
        try {
          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this), _capturedMediaFile)[_capturedMediaFile]) {
            _this.uppy.addFile(_classPrivateFieldLooseBase(_assertThisInitialized(_this), _capturedMediaFile)[_capturedMediaFile]);
          }
        } catch (err) {
          // Logging the error, exept restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this.uppy.log(err, 'warning');
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _stop, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var audioTracks;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (_classPrivateFieldLooseBase(_assertThisInitialized(_this), _stream)[_stream]) {
                  audioTracks = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _stream)[_stream].getAudioTracks();
                  audioTracks.forEach(function (track) {
                    return track.stop();
                  });
                }
                if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder]) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return new Promise(function (resolve) {
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].addEventListener('stop', resolve, {
                    once: true
                  });
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder].stop();
                  clearInterval(_this.recordingLengthTimer);
                });
              case 4:
                _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recordingChunks)[_recordingChunks] = null;
                _classPrivateFieldLooseBase(_assertThisInitialized(_this), _recorder)[_recorder] = null;
                _classPrivateFieldLooseBase(_assertThisInitialized(_this), _audioActive)[_audioActive] = false;
                _classPrivateFieldLooseBase(_assertThisInitialized(_this), _stream)[_stream] = null;
                _this.setPluginState({
                  recordedAudio: null,
                  isRecording: false,
                  recordingLengthSeconds: 0
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function value() {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this), _changeSource, {
      writable: true,
      value: function value(deviceId) {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _stop)[_stop]();
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _start)[_start]({
          deviceId: deviceId
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _updateSources, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this), _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
          _this.setPluginState({
            audioSources: devices.filter(function (device) {
              return device.kind === 'audioinput';
            })
          });
        });
      }
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _mediaDevices)[_mediaDevices] = navigator.mediaDevices;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _supportsUserMedia)[_supportsUserMedia] = _classPrivateFieldLooseBase(_assertThisInitialized(_this), _mediaDevices)[_mediaDevices] != null;
    _this.id = _this.opts.id || 'Audio';
    _this.type = 'acquirer';
    _this.icon = function () {
      return h("svg", {
        className: "uppy-DashboardTab-iconAudio",
        "aria-hidden": "true",
        focusable: "false",
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32"
      }, h("path", {
        d: "M21.143 12.297c.473 0 .857.383.857.857v2.572c0 3.016-2.24 5.513-5.143 5.931v2.64h2.572a.857.857 0 110 1.714H12.57a.857.857 0 110-1.714h2.572v-2.64C12.24 21.24 10 18.742 10 15.726v-2.572a.857.857 0 111.714 0v2.572A4.29 4.29 0 0016 20.01a4.29 4.29 0 004.286-4.285v-2.572c0-.474.384-.857.857-.857zM16 6.5a3 3 0 013 3v6a3 3 0 01-6 0v-6a3 3 0 013-3z",
        fill: "currentcolor",
        "fill-rule": "nonzero"
      }));
    };
    _this.defaultLocale = locale;
    _this.opts = _objectSpread({}, opts);
    _this.i18nInit();
    _this.title = _this.i18n('pluginNameAudio');
    _this.setPluginState({
      hasAudio: false,
      audioReady: false,
      cameraError: null,
      recordingLengthSeconds: 0,
      audioSources: [],
      currentDeviceId: null
    });
    return _this;
  }
  _createClass(Audio, [{
    key: "render",
    value: function render() {
      if (!_classPrivateFieldLooseBase(this, _audioActive)[_audioActive]) {
        _classPrivateFieldLooseBase(this, _start)[_start]();
      }
      var audioState = this.getPluginState();
      if (!audioState.audioReady || !audioState.hasAudio) {
        return h(PermissionsScreen, {
          icon: this.icon,
          i18n: this.i18n,
          hasAudio: audioState.hasAudio
        });
      }
      return h(RecordingScreen
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, audioState, {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO: remove unused
        audioActive: _classPrivateFieldLooseBase(this, _audioActive)[_audioActive],
        onChangeSource: _classPrivateFieldLooseBase(this, _changeSource)[_changeSource],
        onStartRecording: _classPrivateFieldLooseBase(this, _startRecording)[_startRecording],
        onStopRecording: _classPrivateFieldLooseBase(this, _stopRecording)[_stopRecording],
        onDiscardRecordedAudio: _classPrivateFieldLooseBase(this, _discardRecordedAudio)[_discardRecordedAudio],
        onSubmit: _classPrivateFieldLooseBase(this, _submit)[_submit],
        onStop: _classPrivateFieldLooseBase(this, _stop)[_stop],
        i18n: this.i18n,
        showAudioSourceDropdown: this.opts.showAudioSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: audioState.isRecording,
        stream: _classPrivateFieldLooseBase(this, _stream)[_stream]
      }));
    }
  }, {
    key: "install",
    value: function install() {
      var _this2 = this;
      this.setPluginState({
        audioReady: false,
        recordingLengthSeconds: 0
      });
      var target = this.opts.target;
      if (target) {
        this.mount(target, this);
      }
      if (_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
        _classPrivateFieldLooseBase(this, _updateSources)[_updateSources]();
        _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].ondevicechange = function () {
          _classPrivateFieldLooseBase(_this2, _updateSources)[_updateSources]();
          if (_classPrivateFieldLooseBase(_this2, _stream)[_stream]) {
            var restartStream = true;
            var _this2$getPluginState = _this2.getPluginState(),
              audioSources = _this2$getPluginState.audioSources,
              currentDeviceId = _this2$getPluginState.currentDeviceId;
            audioSources.forEach(function (audioSource) {
              if (currentDeviceId === audioSource.deviceId) {
                restartStream = false;
              }
            });
            if (restartStream) {
              _classPrivateFieldLooseBase(_this2, _stop)[_stop]();
              _classPrivateFieldLooseBase(_this2, _start)[_start]();
            }
          }
        };
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (_classPrivateFieldLooseBase(this, _stream)[_stream]) {
        _classPrivateFieldLooseBase(this, _stop)[_stop]();
      }
      this.unmount();
    }
  }]);
  return Audio;
}(UIPlugin);
export { Audio as default };
function _hasAudioCheck2() {
  if (!_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
    return Promise.resolve(false);
  }
  return _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
    return devices.some(function (device) {
      return device.kind === 'audioinput';
    });
  });
}
function _getAudio2() {
  // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
  // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
  // attribute in order to determine the correct MIME type.
  var mimeType = _classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks].find(function (blob) {
    var _blob$type;
    return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
  }).type;
  var fileExtension = getFileTypeExtension(mimeType);
  if (!fileExtension) {
    return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
  }
  var name = "audio-".concat(Date.now(), ".").concat(fileExtension);
  var blob = new Blob(_classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks], {
    type: mimeType
  });
  var file = {
    source: this.id,
    name: name,
    data: new Blob([blob], {
      type: mimeType
    }),
    type: mimeType
  };
  return Promise.resolve(file);
}
Audio.VERSION = packageJson.version;